module.exports = function () {
    return new Worker(__webpack_public_path__ + "0d408dd1b156d233195f.worker.js");
};
